export const MOST_POPULAR_USERS = '/user/most-popular';
export const CATEGORIES = '/category';
export const CATEGORY = (categoryId: string) => `/category/${categoryId}`;
export const POSTS = '/post';
